import { ICommon } from '../../types/common';

const defaultState = {
  isNewbuildingSubdomain: false,
  screenType: 'desktop',
};

export const commonReducer = (state: ICommon) => ({ ...defaultState, ...state });
